"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scriptLoader = void 0;
const cachedScripts = [];
function scriptLoader(src, { scriptText, HTMLAttributes, async, crossOrigin, } = {
    async: true,
}) {
    return new Promise((resolve, reject) => {
        var _a;
        if (cachedScripts.includes(src)) {
            return resolve();
        }
        const script = document.createElement('script');
        script.onload = function onLoad() {
            resolve();
        };
        script.onerror = reject;
        if (async)
            script.async = true;
        if (src)
            script.src = src;
        if (crossOrigin)
            script.crossOrigin = crossOrigin;
        if (scriptText) {
            const text = document.createTextNode(scriptText);
            script.appendChild(text);
        }
        if (HTMLAttributes) {
            for (const key of Object.keys(HTMLAttributes)) {
                script.setAttribute(key, HTMLAttributes[key]);
            }
        }
        if (document.currentScript) {
            (_a = document.currentScript.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(script, document.currentScript);
        }
        else {
            (document.head || document.getElementsByTagName('head')[0]).appendChild(script);
        }
        cachedScripts.push(src);
    });
}
exports.scriptLoader = scriptLoader;
//# sourceMappingURL=file-loader.js.map